/** Hand a text to the browser as a file (the CSV of Análises). `false` when the browser refuses; the screen then says so. */
export function downloadText(filename: string, text: string, type = 'text/csv;charset=utf-8'): boolean {
  try {
    const url = URL.createObjectURL(new Blob([text], { type }));
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    return true;
  } catch {
    return false;
  }
}

/** Hand bytes to the browser as a file (an XLSX; the file of an asynchronous export). `false` when the browser refuses; the screen then says so. */
export function downloadBytes(filename: string, bytes: Uint8Array, type: string): boolean {
  try {
    const copy = new Uint8Array(bytes.length);
    copy.set(bytes);
    const url = URL.createObjectURL(new Blob([copy], { type }));
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    return true;
  } catch {
    return false;
  }
}
